export const boxStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "70vw",
    maxHeight: "90vh",
    bgcolor: "#fff",
    boxShadow: 20,
    overflow: 'visible',
};